import { render, staticRenderFns } from "./CartRecommendBanner.vue?vue&type=template&id=4f150c31&scoped=true&"
import script from "./CartRecommendBanner.vue?vue&type=script&lang=ts&"
export * from "./CartRecommendBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CartRecommendBanner.vue?vue&type=style&index=0&id=4f150c31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f150c31",
  null
  
)

export default component.exports